module.exports = __webpack_public_path__ + "img/logo.41592b0a.png";